var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.dialogs),function(key){return [_c(key,{tag:"component",attrs:{"data":_vm.dialogsData[key]},on:{"close":function($event){return _vm.onClose(key)}}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }